// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable no-comments/disallowComments */

export const Colors = {
    // BRAND
    darkNavy: '#002F4D', // alias for backward compatibility, do not use
    primary: '#002F4D',
    primaryDarkened: '#001C2E',
    primaryMuted: '#335971', // lighter navy for receded/inactive navy surfaces (e.g. past calendar days)

    turquoise: '#00A68D', // alias for backward compatibility, do not use
    secondary: '#00A68D',
    lightTurq: '#E8F6F4', // alias for backward compatibility, do not use
    secondarySoft: '#E8F6F4',
    mediumTurq: '#A1DBD3', // for backward compatibility, phase out

    terraCotta: '#ED6A5A', // alias for backward compatibility, do not use
    accent: '#ED6A5A',
    accentSoft: '#FAF0ED',
    mediumTerraCotta: '#F39C91', // for backward compatibility, phase out
    lightTerraCotta: '#FAF0ED', // for backward compatibility, phase out

    // SEMATIC COLORS USE ONLY WHEN THE CONTEXT REQUIRES IT, NOT AN ACCENT COLOR

    // SUCCESS
    success: '#2E8B57',
    successBackground: '#E7F4EC',
    lightGreen: '#E7F4EC', // alias for backward compatibility, do not use

    // WARNING or ATTENTION
    warning: '#C2492C',
    warningBackground: '#FFF9F1',

    // ERROR or DANGER
    error: '#C3001D',
    mediumRed: '#C3001D', // alias for backward compatibility, do not use
    errorBackground: '#FADFE2',
    lightRed: '#FADFE2', // alias for backward compatibility, do not use

    // NEUTRALS
    white: '#ffffff',

    surface: '#f9fafb', // page / subtle background behind white cards
    faintGrey: '#f9fafb', // alias for backward compatibility, do not use

    fill: '#eef0f1', // neutral fill for panels / columns / rows / inputs / disabled states

    border: '#dee0e2', // dividers and borders — darker than the fills so it stays visible
    lightGrey: '#dee0e2', // alias for backward compatibility, do not use

    textSecondary: '#6b6e71', // the one secondary-text color, both products
    mediumGrey: '#6b6e71', // alias for backward compatibility, do not use
    mediumNavy: '#6b6e71', // alias for backward compatibility, do not use
} as const;

/** Name of a key on the `Colors` palette (e.g. `"primary"`). */
export type ColorToken = keyof typeof Colors;

/** A CSS color string taken from the palette (a value of `Colors`). */
export type ColorsType = (typeof Colors)[ColorToken];
